import { api } from "./api";
import { notifyBillingChanged } from "./billingEvents";

/**
 * startCheckout — single entry point to begin (or change) a subscription for an
 * AUTHENTICATED user. Shared by the Pricing page and CheckoutResume so the launch
 * logic lives in one place.
 *
 * POSTs to /payments/checkout/session. The backend returns either:
 *   { url }              → a fresh Polar checkout: redirect the browser to it.
 *   { updated: true }    → an existing subscriber's plan was changed in place
 *                          (proration, no new subscription): broadcast the change.
 *
 * Returns { redirected } or { updated, plan } so callers can toast/navigate.
 * Throws on API error (caller shows the message).
 */
export async function startCheckout({ plan, billing, promo, originUrl } = {}) {
  const { data } = await api.post("/payments/checkout/session", {
    package_id: plan,
    billing: billing || "annual",
    origin_url: originUrl || window.location.href,
    ...(promo ? { promo_code: promo } : {}),
  });
  if (data?.url) {
    window.location.href = data.url; // off to Polar (page navigates away)
    return { redirected: true };
  }
  if (data?.updated) {
    notifyBillingChanged(); // in-app plan change → sidebar/credit-meter/billing refresh
    return { updated: true, plan: data.plan };
  }
  return { ok: true };
}
